module.exports = __webpack_public_path__ + "img/20200613_093216.196168d9.jpg";